import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import ErrorBoundary from "../Error/ErrorBoundary";
import AppLayout from "../components/layout/AppLaout";
import ProtectedRoute from "../auth/common/ProtectedRoute";
import RefreshTokenView from "../components/refreshToken/RefreshTokenView";
import QrJoinTrigger from "../components/joinTrigger/QrJoinTrigger";
import { Result, Button } from "antd";

/* Páginas */
import PacienteProfile from "../pages/Bitacora/PacienteProfile";
import JoinWaitingRoomPage from "../pages/WaitingRoom/JoinWaitingRoomPage";
import FacturaElectronicaForm from "../pages/FacturaElectronica/FacturaElectronicaForm";

// Payment components
import SuccessView from "../components/Wompi/Success/SuccessView";
import ErrorView from "../components/Wompi/Error/ErrorView";

// Componente interno para confirmación
const JoinConfirmation: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="success"
      title="¡Te has unido a la sala de espera!"
      subTitle="Te avisaremos cuando sea tu turno."
      extra={[
        <Button type="primary" key="home" onClick={() => navigate("/perfil")}>
          Ir a mi perfil
        </Button>,
      ]}
    />
  );
};

export function AppRoutes() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppLayout>
          <Routes>
            <Route path="/refresh-token" element={<RefreshTokenView />} />

            <Route
              path="/waiting-room/join"
              element={
                <ProtectedRoute>
                  <JoinWaitingRoomPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/perfil"
              element={
                <ProtectedRoute>
                  <PacienteProfile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/pacientes/:id"
              element={
                <ProtectedRoute>
                  <PacienteProfile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/waiting-room/join"
              element={<JoinWaitingRoomPage />}
            />

            {/* dispara join en segundo plano desde ?token= */}
            <Route path="/waiting-room/jjoin" element={<QrJoinTrigger />} />

            {/* confirmation tras éxito */}
            <Route
              path="/waiting-room/confirmation"
              element={<JoinConfirmation />}
            />

            {/* Payment success and error routes */}
            <Route
              path="/payment/success"
              element={
                <ProtectedRoute>
                  <SuccessView />
                </ProtectedRoute>
              }
            />

            <Route
              path="/payment/error"
              element={
                <ProtectedRoute>
                  <ErrorView />
                </ProtectedRoute>
              }
            />

            {/* Factura Electrónica */}
            <Route
              path="/factura-electronica"
              element={
                <ProtectedRoute>
                  <FacturaElectronicaForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <JoinConfirmation />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AppLayout>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default AppRoutes;
